document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');
  toggle?.addEventListener('click', () => {
    const open = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!open));
    menu.hidden = open;
  });

  document.querySelectorAll('.product-section').forEach(section => {
    const mainImage = section.querySelector('[data-product-main-image]');
    const price = section.querySelector('[data-product-price]');
    const variantSelect = section.querySelector('[data-product-variant-select]');
    const variantInput = section.querySelector('[data-product-variant-id]');
    const thumbs = [...section.querySelectorAll('[data-product-thumb]')];

    const showImage = imageUrl => {
      if (!mainImage || !imageUrl) return;
      mainImage.removeAttribute('srcset');
      mainImage.removeAttribute('sizes');
      mainImage.src = imageUrl;
    };

    const markActiveThumb = variantId => {
      thumbs.forEach(thumb => {
        thumb.setAttribute('aria-pressed', String(Boolean(variantId) && thumb.dataset.variantId === variantId));
      });
    };

    const syncVariant = variantId => {
      if (!variantSelect || !variantId) return;
      const option = [...variantSelect.options].find(item => item.value === variantId);
      if (!option || option.disabled) return;
      variantSelect.value = variantId;
      if (variantInput) variantInput.value = variantId;
      if (price && option.dataset.variantPrice) price.textContent = option.dataset.variantPrice;
      showImage(option.dataset.variantImage);
      markActiveThumb(variantId);
    };

    variantSelect?.addEventListener('change', event => {
      syncVariant(event.target.value);
    });

    thumbs.forEach(button => {
      button.addEventListener('click', () => {
        if (button.dataset.variantId && variantSelect) {
          syncVariant(button.dataset.variantId);
        } else {
          showImage(button.dataset.productThumb);
          thumbs.forEach(thumb => thumb.setAttribute('aria-pressed', String(thumb === button)));
        }
      });
    });

    if (variantSelect) syncVariant(variantSelect.value);

    if (variantSelect) {
      const options = [...variantSelect.options];
      const titleOf = o => o.textContent.split(' · ')[0].trim();
      const typeOf = o => titleOf(o).includes('Con piedras (+$7)') ? 'stones' : titleOf(o).includes('Sí (+$5)') ? 'themed' : 'base';
      const keyOf = o => { const t=titleOf(o); return t.includes(' / ') ? t.split(' / ')[0].trim() : (t==='No'||t.includes('Sí (+$5)')||t.includes('Con piedras (+$7)') ? '' : t); };
      const base = options.filter(o => typeOf(o) === 'base');
      const themed = options.filter(o => typeOf(o) === 'themed');
      const stones = options.filter(o => typeOf(o) === 'stones');
      if (options.length === 2 && options.some(o=>titleOf(o).includes('Tapa decorada con piedras (+$5)'))) {
        const decorated=options.find(o=>titleOf(o).includes('Tapa decorada con piedras (+$5)'));
        const plain=options.find(o=>o!==decorated);
        const oldLabel=section.querySelector('label[for="' + variantSelect.id + '"]');
        if(oldLabel)oldLabel.hidden=true;
        variantSelect.hidden=true;
        const wrap=document.createElement('div');wrap.className='pc-extra-option';
        const heading=document.createElement('strong');heading.textContent='Decoración de tapa';
        const item=document.createElement('label');item.className='pc-extra-toggle';
        const checkbox=document.createElement('input');checkbox.type='checkbox';checkbox.className='pc-extra-toggle__input';checkbox.checked=true;
        const square=document.createElement('span');square.className='pc-extra-toggle__box';
        const copy=document.createElement('span');copy.className='pc-extra-toggle__copy';
        const name=document.createElement('strong');name.textContent='Tapa decorada con piedras';
        const priceText=document.createElement('small');priceText.textContent='+$5';
        copy.append(name,priceText);item.append(checkbox,square,copy);wrap.append(heading,item);
        variantSelect.insertAdjacentElement('afterend',wrap);
        checkbox.addEventListener('change',()=>syncVariant(checkbox.checked?decorated.value:plain.value));
        syncVariant(decorated.value);
      }
      if (base.length && themed.length && stones.length) {
        const oldLabel = section.querySelector('label[for="' + variantSelect.id + '"]');
        if (oldLabel) oldLabel.hidden = true;
        variantSelect.hidden = true;
        const wrap = document.createElement('div');
        wrap.className = 'pc-extra-option';
        let finish = null;
        if (base.length > 1) {
          const label = document.createElement('label');
          label.textContent = 'Acabado';
          finish = document.createElement('select');
          finish.className = 'pc-base-option__select';
          base.forEach(o => {const opt=document.createElement('option');opt.value=o.value;opt.textContent=keyOf(o)||'Estándar';finish.append(opt);});
          const selectedBase=base.find(o=>keyOf(o)===keyOf(options.find(x=>x.value===variantSelect.value)||base[0]))||base[0];
          finish.value=selectedBase.value;
          wrap.append(label,finish);
        }
        const label=document.createElement('strong');label.textContent='Decoración de tapa';wrap.append(label);
        const choices=document.createElement('div');choices.className='pc-lid-choices';
        const selectedType='themed';
        [['themed','Tapa decorada con la misma temática del vaso','+$5'],['stones','Tapa decorada con piedras','+$7']].forEach(([value,name,price])=>{
          const item=document.createElement('label');item.className='pc-extra-toggle';
          const radio=document.createElement('input');radio.type='radio';radio.name='pc-lid-'+section.id;radio.value=value;radio.className='pc-extra-toggle__input';radio.checked=value===(selectedType==='stones'?'stones':'themed');
          const circle=document.createElement('span');circle.className='pc-extra-toggle__box';
          const copy=document.createElement('span');copy.className='pc-extra-toggle__copy';
          const strong=document.createElement('strong');strong.textContent=name;
          const small=document.createElement('small');small.textContent=price;
          copy.append(strong,small);item.append(radio,circle,copy);choices.append(item);
        });
        wrap.append(choices);variantSelect.insertAdjacentElement('afterend',wrap);
        const apply=()=>{
          const current=finish?base.find(o=>o.value===finish.value):base[0];
          const selected=choices.querySelector('input:checked')?.value;const pool=selected==='stones'?stones:selected==='themed'?themed:base;
          const target=pool.find(o=>keyOf(o)===keyOf(current))||pool[0];
          if(target)syncVariant(target.value);
        };
        choices.addEventListener('click',event=>{const item=event.target.closest('.pc-extra-toggle');if(!item)return;event.preventDefault();const radio=item.querySelector('input');if(!radio)return;const wasChecked=radio.checked;choices.querySelectorAll('input').forEach(input=>{input.checked=false;});radio.checked=!wasChecked;apply();});finish?.addEventListener('change',apply);choices.addEventListener('change',apply);apply();
      }
    }
  });
});


const pcExtraStyle = document.createElement('style');
pcExtraStyle.textContent = `
.pc-extra-option{display:grid;gap:12px;margin:16px 0 20px}.pc-base-option__label{display:block;margin-bottom:-5px;font-weight:750}.pc-base-option__select{width:100%;min-height:48px}.pc-extra-toggle{display:flex;min-height:54px;align-items:center;gap:12px;padding:12px 15px;background:#fff;border:1.5px solid #ddd4e7;border-radius:15px;cursor:pointer;user-select:none;transition:border-color .18s ease,background .18s ease}.pc-extra-toggle:hover{border-color:#bda8d0}.pc-extra-toggle__input{position:absolute;width:1px;height:1px;opacity:0;pointer-events:none}.pc-extra-toggle__box{display:grid;flex:0 0 26px;width:26px;height:26px;place-items:center;border:2px solid #b9adbf;border-radius:7px;background:#fff;transition:.18s ease}.pc-extra-toggle__box::after{content:'✓';color:#fff;font-size:17px;font-weight:900;line-height:1;opacity:0;transform:scale(.7);transition:.18s ease}.pc-extra-toggle__input:checked+.pc-extra-toggle__box{background:#6c2cff;border-color:#6c2cff}.pc-extra-toggle__input:checked+.pc-extra-toggle__box::after{opacity:1;transform:scale(1)}.pc-extra-toggle__input:checked~.pc-extra-toggle__copy{color:#5722bd}.pc-extra-toggle__input:focus-visible+.pc-extra-toggle__box{outline:3px solid rgba(108,44,255,.25);outline-offset:3px}.pc-extra-toggle__copy{display:grid;gap:3px}.pc-extra-toggle__copy strong{font-size:1rem}.pc-extra-toggle__copy small{display:block;color:#746b79;font-size:.76rem;font-weight:500;line-height:1.35}@media(max-width:700px){.pc-extra-toggle{min-height:58px;padding:13px 15px}}
`;
document.head.appendChild(pcExtraStyle);



/* PrintaCrea: barra superior dinámica de envío gratis */
(() => {
 const root=document.querySelector('[data-pc-shipping-progress]');if(!root)return;
 const threshold=Number(root.dataset.threshold||10000),message=root.querySelector('[data-pc-shipping-message]'),fill=root.querySelector('[data-pc-shipping-fill]');
 const money=c=>new Intl.NumberFormat('es-US',{style:'currency',currency:'USD'}).format(Math.max(0,c)/100);
 const render=cart=>{if(!cart)return;const count=Number(cart.item_count||0),total=Number(cart.total_price||0),remaining=Math.max(0,threshold-total),percent=Math.min(100,Math.max(0,total/threshold*100));root.classList.toggle('has-cart',count>0);root.classList.toggle('free-reached',count>0&&remaining<=0);if(message)message.textContent=count===0?'🚚 ENVÍO GRATIS en compras de $100 o más':remaining<=0?'🎉 ¡Ya tienes ENVÍO GRATIS!':`🚚 Te faltan ${money(remaining)} para obtener ENVÍO GRATIS`;if(fill)fill.style.width=percent+'%';document.querySelectorAll('[data-cart-count]').forEach(el=>el.textContent=count)};
 const refresh=()=>fetch((window.Shopify?.routes?.root||'/')+'cart.js',{credentials:'same-origin',headers:{Accept:'application/json'}}).then(r=>r.ok?r.json():null).then(render).catch(()=>{});
 document.addEventListener('shopify:cart:lines-update',refresh);document.addEventListener('shopify:cart:discount-update',refresh);document.addEventListener('change',e=>{if(e.target.closest('form[action*="/cart"]'))setTimeout(refresh,350)});
 const nativeFetch=window.fetch;window.fetch=async function(...args){const response=await nativeFetch.apply(this,args);try{const url=typeof args[0]==='string'?args[0]:args[0]?.url||'';if(/\/cart\/(add|change|update|clear)\.js(?:\?|$)/.test(url))setTimeout(refresh,120)}catch(_){}return response};refresh();
})();
const pcLidStyle=document.createElement('style');pcLidStyle.textContent='.pc-lid-choices{display:grid;gap:10px}.pc-lid-choices .pc-extra-toggle__input{position:absolute;opacity:0;width:1px;height:1px}.pc-lid-choices .pc-extra-toggle__box{border-radius:50%}.pc-lid-choices .pc-extra-toggle__input:checked+.pc-extra-toggle__box{background:#6c2cff;border-color:#6c2cff}.pc-lid-choices .pc-extra-toggle__input:checked+.pc-extra-toggle__box:after{content:"✓";color:white;display:block;text-align:center}.pc-lid-choices .pc-extra-toggle__copy{display:flex;justify-content:space-between;align-items:center;gap:12px}';document.head.append(pcLidStyle);
